module.exports = __webpack_public_path__ + "static/media/ios-information-circle-outline.1060abc0.svg";